import type {
    ETA_ADVISER_PLACEHOLDERS_OBJECT,
    ETA_PLACEHOLDER_TYPE,
    ETA_PLACEHOLDERS_OBJECT,
    ETA_TRACKING_PLACEHOLDERS_OBJECT,
} from 'cpool-constants';
import { ETA_PLACEHOLDER, SALUTATIONS } from 'cpool-constants';
import type {
    SchemaLoanRequestResolver_Get,
    SchemaLoanRequestResolver_GetSummary,
    SchemaTemplateResolver_GetMailTemplates,
    SchemaTemplateResolver_GetOfferTemplates,
    SchemaUserResolver_Get,
} from 'cpool-tables/backend-resolvers';
import { getTitleCase } from 'cpool-utils';

import { GENDERS_SHORTHAND } from '~/constants';

export const getEtaTemplatePlaceholders = ({
    lead,
    template,
    user,
}: {
    user: NonNullable<SchemaUserResolver_Get>;
    template?: SchemaTemplateResolver_GetMailTemplates[number] | SchemaTemplateResolver_GetOfferTemplates[number];
    lead: SchemaLoanRequestResolver_GetSummary[number] | SchemaLoanRequestResolver_Get;
}) => {
    const userPlaceholders = {
        [ETA_PLACEHOLDER.ANREDE_BERATER]:
            user.gender === GENDERS_SHORTHAND.m
                ? getTitleCase(SALUTATIONS.HERR) ?? ''
                : getTitleCase(SALUTATIONS.FRAU) ?? '',
        [ETA_PLACEHOLDER.EMAIL_BERATER]: user.email ?? '',
        [ETA_PLACEHOLDER.NACHNAME_BERATER]: user.lastName ?? '',
        [ETA_PLACEHOLDER.TELEFON_BERATER]: user.phone ?? '',
        [ETA_PLACEHOLDER.TITEL_BERATER]: user.title ?? '',
        [ETA_PLACEHOLDER.VORNAME_BERATER]: user.firstName ?? '',
    } satisfies ETA_ADVISER_PLACEHOLDERS_OBJECT;

    const leadPlaceholders = {
        [ETA_PLACEHOLDER.NACHNAME]: lead.antragsteller1.personendaten.nachname ?? '',
        [ETA_PLACEHOLDER.VORNAME]: lead.antragsteller1.personendaten.vorname ?? '',
        [ETA_PLACEHOLDER.ANREDE]: getTitleCase(lead.antragsteller1.personendaten?.anrede) ?? '',
    } satisfies Pick<
        ETA_PLACEHOLDERS_OBJECT,
        ETA_PLACEHOLDER_TYPE['NACHNAME'] | ETA_PLACEHOLDER_TYPE['VORNAME'] | ETA_PLACEHOLDER_TYPE['ANREDE']
    >;

    const trackingPlaceholders = {
        [ETA_PLACEHOLDER.APPLICANT_ID]: lead.antragsteller1.id,
        [ETA_PLACEHOLDER.FIRST_PARTY_ID]: lead.tracking?.fpid || '',
        [ETA_PLACEHOLDER.LINK_NAME]: '',
        [ETA_PLACEHOLDER.MAIL_ID]: template?.technicalDescription || '',
        [ETA_PLACEHOLDER.MAIL_VERSION_ID]: template?.aggregateVersion?.toString() || '',
    } satisfies ETA_TRACKING_PLACEHOLDERS_OBJECT;

    return {
        leadPlaceholders,
        trackingPlaceholders,
        userPlaceholders,
    };
};
